export function extractProductId(variantId) {
    try {
      const parts = variantId.split('/');
      return parts[parts.length -1];
    } catch (err) {
      return variantId;
    }
}
